import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetch1, fetch3, fetch4, httpAdmin } from "../../Apis/commonApis";

const initialState = {
  existingCategoryTemplates: [],
  clientCarePlanPdfData: [],
  clientCarePlans: [],
  carePlanCategories: [],
  administrativeCarePlans: [],
};

export const fetchClientCarePlans = createAsyncThunk(
  "fetchClientCarePlans",
  async (qString) => {
    const result = await httpAdmin(
      `getClientCarePlan${qString}`,
      "get",
      null,
      null
    );
    return result;
  }
);

export const fetchCarePlanCategories = createAsyncThunk(
  "fetchCarePlanCategories",
  async () => {
    const result = await httpAdmin(
      `getClientCarePlanCategories`,
      "get",
      null,
      null
    );
    return result;
  }
);

export const createClientCarePlan = createAsyncThunk(
  "createClientCarePlan",
  async (body) => {
    const result = await httpAdmin(`createClientCarePlan`, "post", body, null);
    return result;
  }
);

export const fetchAdministrativeCarePlan = createAsyncThunk(
  "fetchAdministrativeCarePlan",
  async (clientId) => {
    const result = await httpAdmin(
      `getAdministrativeCarePlan?clientId=${clientId}`,
      "get",
      null,
      null
    );
    return result;
  }
);

export const UpdateCategoryRiskClientSpecific = createAsyncThunk(
  "UpdateCategoryRiskClientSpecific",
  async (body) => {
    const result = await fetch4(
      `${process.env.REACT_APP_BASEURL}/updateClientCarePlanRiskProfileCategory?careHomeId=${body.currentCareSiteId}&clientId=${body.clientId}&careplanObjId=${body.careplanObjId}`,
      {
        riskProfileCategory: body.risktype,
      },
      {
        Authorization: localStorage.getItem("care_admin_token"),
      }
    );

    return result;
  }
);

export const createCarePlanDirect = createAsyncThunk(
  "createCarePlanDirect",
  async (body) => {
    const result = await fetch4(
      `${process.env.REACT_APP_BASEURL}/createCarePlanDirect`,
      {
        ...body,
      },
      {
        Authorization: localStorage.getItem("care_admin_token"),
      }
    );

    return result;
  }
);

export const createClientCarePlanPdf = createAsyncThunk(
  "createClientCarePlanPdf",
  async (body) => {
    const result = await fetch1(
      `${process.env.REACT_APP_BASEURL}/createClientCarePlanPdf`,
      {
        ...body,
      },
      {
        Authorization: localStorage.getItem("care_admin_token"),
      }
    );

    return result;
  }
);

export const editClientCarePlanPdf = createAsyncThunk(
  "editClientCarePlanPdf",
  async ({ review, documentId }) => {
    const result = await fetch4(
      `${process.env.REACT_APP_BASEURL}/editClientCarePlanPdf?documentId=${documentId}`,
      {
        nextReview: review,
      },
      {
        Authorization: localStorage.getItem("care_admin_token"),
      }
    );

    return result;
  }
);

export const deleteCarePlanDirect = createAsyncThunk(
  "deleteCarePlanDirect",
  async (body) => {
    const result = await fetch4(
      `${process.env.REACT_APP_BASEURL}/deleteCarePlanDirect`,
      {
        ...body,
      },
      {
        Authorization: localStorage.getItem("care_admin_token"),
      }
    );

    return result;
  }
);

export const getCarePlanQueAndAns = createAsyncThunk(
  "getCarePlanQueAndAns",
  async () => {
    const result = await fetch3(
      `${process.env.REACT_APP_BASEURL}/getCarePlanQueAndAns`,
      "get"
    );
    return result;
  }
);

export const getClientCarePlanPdf = createAsyncThunk(
  "getClientCarePlanPdf",
  async (body) => {
    const result = await fetch3(
      `${process.env.REACT_APP_BASEURL}/getClientCarePlanPdf?adminId=${body.adminId}&careHomeId=${body.currentCareSiteId}&clientId=${body.clientId}`,
      "get"
    );
    return result;
  }
);

const ClientCarePlanSlice = createSlice({
  name: "ClientCarePlanSlice",
  initialState,
  reducers: {
    selectMultipleIds(state = initialState, action) {
      //   state.shiftTaskIds = action.payload.ids;
    },
  },

  extraReducers: {
    [fetchClientCarePlans.fulfilled]: (state, { payload }) => {
      state.clientCarePlans = payload.data;
    },
    [fetchCarePlanCategories.fulfilled]: (state, { payload }) => {
      state.carePlanCategories = payload.data;
    },
    [fetchAdministrativeCarePlan.fulfilled]: (state, { payload }) => {
      state.administrativeCarePlans = payload.data;
    },
    [UpdateCategoryRiskClientSpecific.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [createCarePlanDirect.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [getCarePlanQueAndAns.fulfilled]: (state, { payload }) => {
      const categoryTemplateObj = {};
      payload?.data?.category?.forEach((elem) => {
        categoryTemplateObj[elem.name] = elem.subCategory;
      });
      state.existingCategoryTemplates = categoryTemplateObj;
      state.loading = false;
    },
    [getClientCarePlanPdf.fulfilled]: (state, { payload }) => {
      state.clientCarePlanPdfData = payload.data.map((item) => {
        return {
          ...item,
          creationDate: item.createdAt?.split("T")[0],
          createdBy: item.createdBy,
          review: Object.keys(item).includes("review") ? item.review : "",
          image: Object.keys(item).includes("pdfLink") ? item.pdfLink : "",
          fileName: Object.keys(item).includes("pdfLink")
            ? item.pdfLink
                .split("/")
                .pop()
                .replace(/\b\d{5,}-\b/g, "")
            : "",
        };
      });
      state.loading = false;
    },
    [createClientCarePlanPdf.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.carePlanRemainderDatePopupStatus = false;
    },
    [editClientCarePlanPdf.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.carePlanRemainderDatePopupStatus = false;
    },
  },
});

export const { selectMultipleIds } = ClientCarePlanSlice.actions;
export default ClientCarePlanSlice.reducer;
